import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { Bundesland, Subject } from '@chancenwerk/enums/enums.js';
import { Course } from './Course.js';

/**
 * @entity CourseGraduation
 *
 * Termine für den CHANCENabschluss
 */
@Entity()
export class CourseGraduation extends Course {
  public static override _class = 'CourseGraduation';

  @Field(() => String)
  public subject: Maybe<Subject>;

  @Field(() => String)
  public bundesland: Maybe<Bundesland>;
}
